/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as ContinueWatching from './myTvContinueWatching';
import * as FolderAssets from './myTvFolderAssets';
import * as Recordings from './myTvRecordings';
import * as SecondLevel from './myTvSecondLevel';
import * as ThirdLevel from './myTvThirdLevel';

export default combineReducers({
  continueWatchingAssets: ContinueWatching.default,
  folderAssets: FolderAssets.default,
  recordings: Recordings.default,
  secondLevelRails: SecondLevel.default,
  thirdLevelRails: ThirdLevel.default,
});

export const Selectors = {
  ...ContinueWatching.Selectors,
  ...FolderAssets.Selectors,
  ...Recordings.Selectors,
  ...SecondLevel.Selectors,
  ...ThirdLevel.Selectors,
};

export const ActionCreators = {
  ...ContinueWatching.ActionCreators,
  ...FolderAssets.ActionCreators,
  ...SecondLevel.ActionCreators,
  ...ThirdLevel.ActionCreators,
};

export const sagas = [
  call(ContinueWatching.saga),
  call(FolderAssets.saga),
  call(Recordings.saga),
  call(SecondLevel.saga),
  call(ThirdLevel.saga),
];
